import { render, staticRenderFns } from "./RecipeListSection.vue?vue&type=template&id=ad0702b2&scoped=true&"
import script from "./RecipeListSection.vue?vue&type=script&lang=js&"
export * from "./RecipeListSection.vue?vue&type=script&lang=js&"
import style0 from "./RecipeListSection.vue?vue&type=style&index=0&id=ad0702b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0702b2",
  null
  
)

export default component.exports